import { z } from "zod";
import { DateString } from "@/lib/api/schemas/patterns";
import { DecimalNumber } from "@/lib/api/schemas/shared";

/** A client (tenant) option — used by the superuser invitation picker. */
export const ClientOut = z.object({
  id: z.number(),
  name: z.string(),
});

export const UsersListOut = z.object({
  id: z.number(),
  date_joined: z.string(),
  member_since: z.string().nullable().optional(),
  last_login: z.string().nullable(),
  email: z.string(),
  first_name: z.string(),
  last_name: z.string(),
  username: z.string(),
  is_active: z.boolean(),
  client_id: z.number().nullable().optional(),
  client_name: z.string().nullable().optional(),
  sign_in_method: z.string().optional(),
});

export const UserAccessOut = z.object({
  success: z.boolean(),
  message: z.string(),
  id: z.number(),
  is_active: z.boolean(),
});

export const UsageOut = z.object({
  artifact_storage_gb_hours: DecimalNumber,
  file_storage_gb_hours: DecimalNumber,
  artifact_storage_cost: DecimalNumber,
  file_storage_cost: DecimalNumber,
  total_storage_cost: DecimalNumber,
  tokens_input: z.number().int(),
  tokens_output: z.number().int(),
  total_tokens: z.number().int(),
  input_token_cost: DecimalNumber,
  output_token_cost: DecimalNumber,
  total_token_cost: DecimalNumber,
  worker_seconds: z.number().int(),
  total_worker_cost: DecimalNumber,
  currency: z.string(),
  last_calculated_at: DateString.nullable().optional(),
});
